module.exports = __webpack_public_path__ + "img/nodata.7c27208b.png";